import { createRoute } from "@tanstack/react-router";
import { rootRoute } from '../App'
import { getDiseaseStatsQuery, getReviewTypeStatsQuery } from '../api/statsApi';
import { Home } from "./Home.page";
import { FullPageLoader } from '../components/FullPageLoader';
import { API_BASE_URL } from '../config';

export const homeRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/",
    loader: ({ context }) => {
        //Temporary wake up call to backend.
        fetch(`${API_BASE_URL}/_health/live`).catch(() => {});

        return Promise.all([
            context.queryClient.prefetchQuery(getDiseaseStatsQuery()),
            context.queryClient.prefetchQuery(getReviewTypeStatsQuery()),
        ]);
    },
    component: Home,
    pendingComponent:  () => <FullPageLoader />,
});
